import api from '@/api'
export default {
  methods: {
    async getCopyNode(oldNodes, flowid) {
      var newNodes = []
      var newNodePromise = []
      for (let index = 0; index < oldNodes.length; index++) {
        newNodePromise.push(this.copyNode(oldNodes[index], flowid))
      }
      var newNodes = await Promise.all(newNodePromise)

      newNodes.forEach((node, index) => {
        var answers = []
        var ans = null

        if (node.answer && node.answer.length > 0 && node.answer[0].length > 0) {
          node.answer[0].forEach((answer, aindex) => {
            if (answer.type == 'condition') {
              ans = answer
              var conditions = ans.condition
              var con = []
              conditions.forEach((condition, cindex) => {
                var nnode = newNodes.find(nnode => {
                  return nnode.oldid == condition.to
                })
                if (nnode) {
                  conditions[cindex].to = nnode.id
                } else {
                  conditions[cindex].to = null
                }
              })
              ans.condition = conditions
              answers.push(ans)
            } else if (answer.type == 'random') {
              ans = answer
              var tos = ans.to
              tos.forEach((to, tindex) => {
                var nnode = newNodes.find(nnode => {
                  return nnode.oldid == to
                })
                if (nnode) {
                  tos[tindex] = nnode.id
                } else {
                  tos[tindex] = null
                }
              })
              ans.to = tos

              answers.push(ans)
            } else {
              answers.push(answer)
            }
          })
        }
        newNodes[index].answer[0] = answers

        var connections = []
        var con = null

        node.connected_intents.forEach((connection, cindex) => {
          if (connection.type == 'condition') {
            var conditions = []
            con = connection
            connection.condition.forEach((condition, ccindex) => {
              var nnode = newNodes.find(nnode => {
                return nnode.oldid == condition.to
              })
              if (nnode) {
                con.condition[ccindex].to = nnode.id
              } else {
                con.condition[ccindex].to = null
              }
            })
            connections.push(con)
          } else if (connection.type == 'random') {
            if (node.answer && node.answer.length > 0 && node.answer[0].length > 0) {
              connections.push(node.answer[0][0])
            }
          } else if (connection.type == 'flow') {
            connections.push(connection)
          } else {
            var nnode = newNodes.find(nnode => {
              return nnode.oldid == connection.to
            })
            if (nnode) {
              con = newNodes[index].connected_intents[cindex]
              con.to = nnode.id
              connections.push(con)
            }
          }
        })

        newNodes[index].connected_intents = connections
      })

      return Promise.resolve(newNodes)
    },

    async copyNode(node, flowid) {
      var data = node
      data.x = data.x + 15
      data.y = data.y + 15
      data.connected_intents = JSON.stringify(data.connected_intents)
      data.answer = JSON.stringify(data.answer)
      data.flowid = flowid
      var oldid = node.id
      if (data.id) {
        delete data.id
      }

      try {
        var response = await api.addNode(data)
        if (response.data && response.data.length > 0) {
          var result = response.data[0]
          try {
            result.connected_intents =
              result.connected_intents != null ? JSON.parse(result.connected_intents) : []
          } catch (e) {
            result.connected_intents = []
          }
          try {
            result.answer = result.answer != null ? JSON.parse(result.answer) : []
          } catch (e) {
            result.answer = []
          }
          result.oldid = oldid
          result.userinput = {
            from: 0,
            input: '',
            type: 'input'
          }
          return result
        }
        return null
      } catch (error) {
        console.error(error)
        return null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/copyNodeMixin.js